export default __webpack_public_path__ + "static/service1-7347902b662fe686cab4c51aafae14cc.png";